import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";

// const serverErrorText = "服务器发生错误，请稍后再试";
const serverErrorText = "A server error occurred. Please try again later.";
// create an axios instance
const service = axios.create({
  baseURL: "", // url = base url + request url
  timeout: 60 * 1000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    config.cancelToken = new axios.CancelToken(cancel => {
      //使用vuex 定义pushCancel，请求进来存入
      store.dispatch("users/pushCancel", { cancelToken: cancel });
    });
    if (store.getters.token) {
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["Token"] = getToken();
    }
    return config;
  },
  error => {
    // do something with request error
    return Promise.reject(error);
    //return config;
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    // console.log(res, "返回回来的数据");
    // if the custom code is not 0, it is judged as an error.
    if (res.Code && res.Code !== 0) {
      //判断登陆状态， 取消后续请求
      if (res.Code === 1) {
        store.dispatch("users/clearCancel");
        Message({
          message: res.Msg,
          type: "error"
        });
        return Promise.reject(res.Msg);
      }
      if (res.Code === 2) {
        store.dispatch("users/clearCancel");
        // to re-login
        MessageBox.confirm(res.Msg, {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            store.dispatch("users/resetToken").then(() => {
              store.state.users.loginsInfo.dialogVisible = true;
              window.location.replace("#/Home");
            });
          })
          .catch(() => {
            store.dispatch("users/resetToken").then(() => {});
          });
        return Promise.reject(res.Msg);
      }
      if (res.Code === 3) {
        MessageBox.confirm("您的账号还未注册，请先注册！", {
          confirmButtonText: "点击注册",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            // store.dispatch("users/resetToken").then(() => {
            //   // router.push("/AllCourses");
            store.state.users.registeredInfo.dialogVisible = true;
          })
          .catch(() => {
            store.dispatch("users/resetToken").then(() => {});
          });
        return Promise.reject(res.Msg);
      }
      if (res.Code === 4) {
        console.log(" res", res);
        return Promise.reject(res.Msg);
      }
    } else {
      return res;
    }
  },
  error => {
    // console.log("后台返回来的报错",);
    handleError(error);
    return Promise.reject(error);
  }
);
/*
 * 总共有多种错误：
 * 1. 网络异常直接fail
 * 2. 服务器报错500等
 */
const handleError = error => {
  if (error.code === "ERR_NETWORK") {
    error.message = "";
    Message({
      message: "ERR_NETWORK",
      type: "error",
      duration: 5 * 1000
    });
  } else {
    Message({
      message: serverErrorText,
      type: "error",
      duration: 5 * 1000
    });
  }
};

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js